var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicCodeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1084_110175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.02 1.97C14.4 1.35 13.55 1 12.67 1C11.79 1 10.94 1.35 10.31 1.97C9.68 2.6 9.33 3.45 9.33 4.33V5.66H2.67C2.49 5.66 2.32 5.73 2.19 5.86C2.07 5.98 2 6.15 2 6.33V12.33C2 12.86 2.21 13.37 2.59 13.74C2.96 14.12 3.47 14.33 4 14.33H10.67C11.2 14.33 11.71 14.12 12.08 13.74C12.46 13.37 12.67 12.86 12.67 12.33V6.33C12.67 6.15 12.6 5.98 12.47 5.86C12.35 5.73 12.18 5.66 12 5.66H10.67V4.33C10.67 3.8 10.88 3.29 11.25 2.92C11.63 2.54 12.14 2.33 12.67 2.33C13.2 2.33 13.71 2.54 14.08 2.92C14.46 3.29 14.67 3.8 14.67 4.33V4.56H16V4.33C16 3.45 15.65 2.6 15.02 1.97ZM9.71 10.71C9.53 10.9 9.27 11 9.01 11C8.74 11 8.49 10.9 8.3 10.71C8.11 10.52 8.01 10.27 8.01 10C8.01 9.73 8.11 9.48 8.3 9.29C8.49 9.1 8.74 9 9.01 9C9.27 9 9.53 9.1 9.71 9.29C9.9 9.48 10.01 9.73 10.01 10C10.01 10.27 9.9 10.52 9.71 10.71Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1084_110175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 13.33,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicCodeLock);
export default __webpack_public_path__ + "static/media/PublicCodeLock.b40a80005d18c706737ce416d8869bc7.svg";
export { ForwardRef as ReactComponent };